// extracted by mini-css-extract-plugin
export var proBadge = "rtPXl";